import request from './request'

export const getRunnerReferrerWalletList = (params) => {
  return request({
    url: '/admin/runner-referrer-wallets',
    method: 'get',
    params
  })
}

export const getRunnerReferrerWalletInfo = (runnerReferrerId) => {
  return request({
    url: `/admin/runner-referrer-wallets/referrer/${runnerReferrerId}`,
    method: 'get'
  })
}

export const getRunnerReferrerWalletDetail = (id) => {
  return request({
    url: `/admin/runner-referrer-wallets/${id}`,
    method: 'get'
  })
}

export const getRunnerReferrerWalletTransactions = (runnerReferrerId, params) => {
  return request({
    url: `/admin/runner-referrer-wallets/${runnerReferrerId}/transactions`,
    method: 'get',
    params
  })
}

export const updateRunnerReferrerWallet = (id, data) => {
  return request({
    url: `/admin/runner-referrer-wallets/${id}`,
    method: 'put',
    data
  })
}
